import React from 'react';

export default function QuickActions({ onSelectSection }) {
  const quickActions = [
    {
      title: 'Find a Parish',
      route: 'churches',
      icon: (
        /* Church Icon with Cross */
        <svg className="w-8 h-8 text-[#842343] transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2v4M10 4h4" />
          <path d="M12 6L4 12v9h16v-9z" />
          <path d="M9 21v-5a3 3 0 0 1 6 0v5" />
          <path d="M4 12h16" />
        </svg>
      )
    },
    {
      title: 'Daily Readings',
      route: 'readings',
      icon: (
        /* Open Book with Ribbon Bookmark */
        <svg className="w-8 h-8 text-[#842343] transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M2 5.5A2.5 2.5 0 0 1 4.5 3H11v17H4.5A2.5 2.5 0 0 0 2 22.5z" />
          <path d="M22 5.5A2.5 2.5 0 0 0 19.5 3H13v17h6.5a2.5 2.5 0 0 1 2.5 2.5z" />
          <path d="M10 3v8l2-1.5 2 1.5V3" />
        </svg>
      )
    },
    {
      title: 'Prayer Requests',
      route: 'contact',
      icon: (
        /* Praying Hands with Dual-Tone Details */
        <svg className="w-8 h-8 text-[#842343] transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 3.5c-.8 1.4-2 3.3-2.8 5.2-.8 1.8-.9 4-.4 5.8l2.2 3.5h2l2.2-3.5c.5-1.8.4-4-.4-5.8-.8-1.9-2-3.8-2.8-5.2z" />
          <path d="M7.5 9.5l2 3.5" />
          <path d="M16.5 9.5l-2 3.5" />
          <path d="M9 19.5h6" stroke="#D4A64A" strokeWidth="2.2" />
          <path d="M8 22h8" stroke="#D4A64A" strokeWidth="2.2" />
        </svg>
      )
    },
    {
      title: 'Events',
      route: 'events',
      icon: (
        /* Calendar with grid dots */
        <svg className="w-8 h-8 text-[#842343] transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="3" />
          <path d="M16 2v4M8 2v4M3 10h18" />
          <circle cx="8" cy="14" r="0.75" fill="currentColor" />
          <circle cx="12" cy="14" r="0.75" fill="currentColor" />
          <circle cx="16" cy="14" r="0.75" fill="currentColor" />
          <circle cx="8" cy="18" r="0.75" fill="currentColor" />
          <circle cx="12" cy="18" r="0.75" fill="currentColor" />
          <circle cx="16" cy="18" r="0.75" fill="currentColor" />
        </svg>
      )
    },
    {
      title: 'Live Streaming',
      route: 'live',
      icon: (
        /* Play Screen / Live Streaming TV */
        <svg className="w-8 h-8 text-[#842343] transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2.5" y="4.5" width="19" height="15" rx="4" />
          <polygon points="10 9 15.5 12 10 15 10 9" fill="currentColor" strokeWidth="0" />
        </svg>
      )
    },
    {
      title: 'Photo Gallery',
      route: 'gallery',
      icon: (
        /* Photo Gallery Frame with Sun & Mountain */
        <svg className="w-8 h-8 text-[#842343] transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="3" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <path d="M21 16l-5-5-8 8" />
          <path d="M14 14l2-2 5 5" />
        </svg>
      )
    },
    {
      title: 'Presbyters',
      route: 'lights',
      icon: (
        /* Presbyters / Clerical Minister Icon */
        <svg className="w-8 h-8 text-[#842343] transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="10" cy="7" r="4" />
          <path d="M19 8v6M16 11h6" />
        </svg>
      )
    },
    {
      title: 'Contact Us',
      route: 'contact',
      icon: (
        /* Phone Call with Ringing Waves */
        <svg className="w-8 h-8 text-[#842343] transition-transform duration-300 group-hover:scale-110 group-hover:-translate-y-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
          <path d="M14.05 2a9 9 0 0 1 7.95 7.95" />
          <path d="M14.05 6A5 5 0 0 1 18 9.95" />
        </svg>
      )
    },
  ];

  return (
    <section className="relative z-30 -mt-14 sm:-mt-18 md:-mt-20 lg:-mt-24 max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 mb-6">
      <div className="bg-white rounded-[28px] sm:rounded-[36px] shadow-[0_15px_45px_rgba(0,0,0,0.06)] py-5 sm:py-6 px-3 sm:px-5 lg:px-6 border border-[#EAE0DA]">
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 items-center lg:divide-x lg:divide-[#EDE3DC] gap-y-4 lg:gap-y-0">
          {quickActions.map((action, idx) => (
            <a
              key={idx}
              href={`/${action.route}`}
              onClick={(e) => {
                e.preventDefault();
                onSelectSection(action.route);
              }}
              className="group flex flex-col items-center justify-center text-center w-full py-2 px-2 transition-all duration-300 hover:bg-[#FAF6F2]/80 rounded-2xl cursor-pointer"
            >
              <div className="flex items-center justify-center h-9 mb-2.5">
                {action.icon}
              </div>
              <span className="font-sans text-[#1E1815] group-hover:text-[#842343] text-[13px] sm:text-[13.5px] font-semibold leading-tight transition-colors whitespace-nowrap">
                {action.title}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
